<main class="">
  <div class="event-main">
    <div class="container">
      <div class="div-header">
        <h1>Gallery</h1>
      </div>
      <div class="div-contents" *ngIf="noData == false">
        <div class="row">
          <div
            class="col-lg-4 col-md-4 col-sm-6 col-12"
            *ngFor="let list of galleryListData; let i = index"
          >
            <div class="gallery-div">
              <div class="gallery-img-div" (click)="lightbox.open(i)">
                <img
                  [src]="list.galleryImageName"
                  alt=""
                  class="img-fluid gallery-img"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="div-contents" *ngIf="noData == true">
        <div class="text-center no-data-div">
          <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
          <h6>Coming soon</h6>
        </div>
      </div>
    </div>
  </div>
</main>
<ng-template
  #itemTemplate
  let-index="index"
  let-type="type"
  let-data="data"
  let-currIndex="currIndex"
>
  <ng-container *ngIf="type === 'imageViewer' && index === currIndex">
    <img [src]="data.src" class="img-fluid modal-show" alt="" />
  </ng-container>
</ng-template>
